import { Component, HostListener } from '@angular/core'
import { SharedService } from '../../@core/services/shared.service'
import { NbDialogRef, NbDialogService } from '@nebular/theme'
import { FieldType, PvsFormDialogComponent } from '../pvs-form-dialog/pvs-form-dialog.component'

@Component({
    templateUrl: './scan-barcode.component.html',
    styleUrls: ['./scan-barcode.component.scss'],
    selector: 'app-scan-barcode',
})
export class ScanBarcodeComponent {
    barcode: string = ''
    isWorking: boolean = false

    constructor(
        protected dialogRef: NbDialogRef<any>,
        private dialogService: NbDialogService,
        public sharedService: SharedService
    ) {}

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(e: KeyboardEvent) {
        console.log(e.key)
        if (e.key === 'Enter') {
            console.log(this.barcode)
            // finish detection
            this.isWorking = false
            // check
            if (/^#\w+!$/g.test(this.barcode)) {
                // valid
                // remove #! symbol
                const res = this.barcode.replace(/^#/, '').replace(/!$/, '')
                this.dialogRef.close(res)
            } else {
                this.barcode = ''
                this.sharedService.showErrorMessage('Invalid QR Code!')
            }
        } else {
            if (e.key === '#') {
                this.isWorking = true
                this.barcode = '#'
                return
            }
            if (this.isWorking) {
                this.barcode += e.key
            }
        }
    }
    onEnterCodeClick() {
        this.dialogService
            .open(PvsFormDialogComponent, {
                context: {
                    settings: {
                        title: 'Input code',
                        fields: [
                            {
                                name: 'code',
                                type: FieldType.STRING,
                                title: 'Code',
                            },
                        ],
                        data: {
                            code: '',
                        },
                        cssWidth: '400px',
                    },
                },
            })
            .onClose.subscribe((res) => {
                const code = res?.editedData?.code
                if (!code) {
                    return
                }
                // check
                if (/^#?\w+!?$/g.test(code)) {
                    // valid
                    // remove #! symbol
                    const b = code.replace(/^#/, '').replace(/!$/, '')
                    this.dialogRef.close(b)
                    return
                }
                this.sharedService.showErrorMessage('Invalid QR Code!')
            })
    }
}
